<template>
  <fin-data-loader :resolver="loadData"
                   fullpage>
    <template #content>
      <div class="home">
        <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                     v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                     fluid>
          <v-row>
            <v-col id="gdprContent" cols="12">
              <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Datenschutzerklärung</h1>

              <h2>1. Datenschutz auf einen Blick</h2>

              <h3>Allgemeine Hinweise</h3>
              <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
                passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
                persönlich
                identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer
                unter
                diesem Text aufgeführten Datenschutzerklärung.</p>

              <h3>Datenerfassung auf dieser Website</h3>

              <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
              <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können
                Sie
                dem Abschnitt "Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.</p>

              <p><strong>Wie erfassen wir Ihre Daten?</strong></p>
              <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um
                Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
              <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere
                IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder
                Uhrzeit
                des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website
                betreten.</p>

              <p><strong>Wofür nutzen wir Ihre Daten?</strong></p>
              <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten.
                Andere
                Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>

              <p><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong></p>
              <p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer
                gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
                Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                können
                Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                bestimmten
                Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren
                steht
                Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
              <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</p>

              <h3>Analyse-Tools und Tools von Drittanbietern</h3>

              <p>Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor
                allem
                mit sogenannten Analyseprogrammen.</p>
              <p>Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden
                Datenschutzerklärung.</p>


              <h2>2. Hosting und Content Delivery Networks (CDN)</h2>

              <h3>Externes Hosting</h3>

              <p>Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die
                auf
                dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.
                a.
                um
                IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen,
                Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
              <p>Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
                bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und
                effizienten
                Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f
                DSGVO).</p>
              <p>Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten
                erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.</p>
              <p>Wir setzen folgenden Hoster ein:</p>
              <p>Amazon Web Services EMEA Sàrl, Niederlassung Deutschland<br/>
                Amtsgericht München HRB 242240<br/>
                Marcel-Breuer-Str. 12, D-80807 München</p>

              <p><strong>Abschluss eines Vertrages über Auftragsverarbeitung</strong></p>
              <p>Um die datenschutzkonforme Verarbeitung zu gewährleisten, haben wir einen Vertrag über
                Auftragsverarbeitung
                mit unserem Hoster geschlossen.</p>


              <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>

              <h3>Datenschutz</h3>

              <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
                personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie
                dieser
                Datenschutzerklärung.</p>
              <p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene
                Daten
                sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung
                erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem
                Zweck
                das geschieht.</p>
              <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
                Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
                nicht
                möglich.</p>

              <h3>Hinweis zur verantwortlichen Stelle</h3>

              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <p>Dr. iur. Christian Borchers<br/>
                Datenschutz Süd GmbH<br/>
                Wörthstraße 15<br/>
                97082 Würzburg<br/>
                E-Mail: <a href="mailto:office@datenschutz-sued.de">office@datenschutz-sued.de</a></p>
              <p>Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit
                anderen
                über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o.
                Ä.)
                entscheidet.</p>

              <h3>Speicherdauer</h3>

              <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben
                Ihre
                personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
                berechtigtes
                Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
                personenbezogenen
                Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt
                die
                Löschung nach Fortfall dieser Gründe.</p>

              <h3>Hinweis zur Datenweitergabe in die USA</h3>

              <p>Auf unserer Website sind unter anderem Tools von Unternehmen mit Sitz in den USA eingebunden. Wenn
                diese
                Tools aktiv sind, können Ihre personenbezogenen Daten an die US-Server der jeweiligen Unternehmen
                weitergegeben werden. Wir weisen darauf hin, dass die USA kein sicherer Drittstaat im Sinne des
                EU-Datenschutzrechts sind. US-Unternehmen sind dazu verpflichtet, personenbezogene Daten an
                Sicherheitsbehörden herauszugeben, ohne dass Sie als Betroffener hiergegen gerichtlich vorgehen könnten.
                Es
                kann daher nicht ausgeschlossen werden, dass US-Behörden (z.B. Geheimdienste) Ihre auf US-Servern
                befindlichen Daten zu Überwachungszwecken verarbeiten, auswerten und dauerhaft speichern. Wir haben auf
                diese Verarbeitungstätigkeiten keinen Einfluss.</p>

              <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können
                eine
                bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
                Datenverarbeitung bleibt vom Widerruf unberührt.</p>

              <h3>Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21
                DSGVO)</h3>

              <p>WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE
                JEDERZEIT
                DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
                PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES
                PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER
                DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN
                NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
                NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
                GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1
                DSGVO).</p>
              <p>WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT,
                JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
                DERARTIGER
                WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG
                STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE
                DER
                DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).</p>

              <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>

              <p>Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
                Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
                oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger
                verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.</p>

              <h3>Recht auf Datenübertragbarkeit</h3>

              <p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
                automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format
                aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
                verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p>

              <h3>SSL- bzw. TLS-Verschlüsselung</h3>

              <p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
                Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
                TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
                Browsers
                von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>
              <p>Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln,
                nicht
                von Dritten mitgelesen werden.</p>

              <h3>Auskunft, Löschung und Berichtigung</h3>

              <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
                Auskunft
                über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
                Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu
                weiteren
                Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.</p>

              <h3>Recht auf Einschränkung der Verarbeitung</h3>

              <p>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                Hierzu
                können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
                folgenden
                Fällen:</p>
              <ul>
                <li>Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen
                  wir
                  in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
                  Einschränkung
                  der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>
                <li>Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt
                  der
                  Löschung die Einschränkung der Datenverarbeitung verlangen.
                </li>
                <li>Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
                  Verteidigung
                  oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die
                  Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>
                <li>Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen
                  Ihren
                  und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen,
                  haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>
              </ul>
              <p>Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von
                ihrer
                Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung
                von
                Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus
                Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats
                verarbeitet
                werden.</p>

              <h3>Widerspruch gegen Werbe-E-Mails</h3>

              <p>Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht
                ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber
                der
                Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
                Werbeinformationen, etwa durch Spam-E-Mails, vor.</p>


              <h2>4. Datenerfassung auf dieser Website</h2>

              <h3>Cookies</h3>

              <p>Unsere Internetseiten verwenden so genannte "Cookies". Cookies sind kleine Textdateien und richten auf
                Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
                (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies
                werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert,
                bis
                Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.</p>
              <p>Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie
                unsere
                Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die Nutzung bestimmter
                Dienstleistungen des Drittunternehmens (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).</p>
              <p>Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte
                Websitefunktionen ohne diese nicht funktionieren würden (z.B. die Warenkorbfunktion oder die Anzeige von
                Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten oder Werbung anzuzeigen.</p>
              <p>Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige Cookies) oder zur
                Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (funktionale Cookies, z. B. für die
                Warenkorbfunktion) oder zur Optimierung der Website (z.B. Cookies zur Messung des Webpublikums)
                erforderlich
                sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere
                Rechtsgrundlage
                angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur
                technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur
                Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden Cookies ausschließlich
                auf
                Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung ist jederzeit
                widerrufbar.</p>
              <p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
                Cookies
                nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie
                das
                automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von
                Cookies
                kann die Funktionalität dieser Website eingeschränkt sein.</p>
              <p>Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hierüber
                im
                Rahmen dieser Datenschutzerklärung gesondert informieren und ggf. eine Einwilligung abfragen.</p>

              <h3>Server-Log-Dateien</h3>

              <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
                Server-Log-Dateien,
                die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
              <ul>
                <li>Browsertyp und Browserversion</li>
                <li>verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>
              <p>Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber
                hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner
                Website
                – hierzu müssen die Server-Log-Files erfasst werden.</p>

              <h3>Anmeldung über Apple- respektive Google Konten</h3>

              <p>Wir bieten Ihnen die Möglichkeit sich bei unserer Anwendung mit den Anmeldediensten von Apple oder
                Google per Single Sign-on (SSO) zu registrieren bzw. anzumelden. Zu diesem Zweck werden Sie auf die
                entsprechenden Anmeldeseiten von Apple respektive Google weitergeleitet, wo Sie sich mit Ihrer Apple-ID
                oder Ihrem Google Nutzer anmelden. Hierdurch wird Ihr Log-in Profil des jeweiligen Dienstleister und mit
                der Anmeldung an unser System verknüpft. Durch diese Verknüpfung erhalten und nutzen wir vom Apple-
                respektive Google-Konto folgende Informationen:
              </p>
              <ul>
                <li>Google: Username, Vorname, Nachname und E-Mail-Adresse</li>
                <li>Apple: Name und E-Mail Adresse (letztere nur mit ausdrücklichem Einverständnis, auf Ihren Wunsch
                  wird diese maskiert und unsere Kommunikation erfolgt über Apples Weiterleitungsservice)
                </li>
              </ul>
              <p>
                Weitere Informationen zu den Anmeldediensten von Apple und Google entnehmen Sie bitte den
                <a href="https://www.apple.com/de/legal/privacy/de-ww/" target="_blank">Datenschutzhinweisen</a> und den
                <a href="https://www.apple.com/de/legal/internet-services/terms/site.html" target="_blank">Nutzungsbedingungen</a>
                von Apple sowie Google
                <a href="https://policies.google.com/privacy?hl=de&fg=1" target="_blank">Datenschutzhinweise, </a>
                <a href="https://policies.google.com/terms?hl=de&fg=1" target="_blank">Nutzungsbedingungen </a>.
              </p>

              <h3>Kontaktformular</h3>

              <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
                inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall
                von
                Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
              <p>Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
                mit
                der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich
                ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
                effektiven
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung
                (Art.
                6
                Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.</p>
              <p>Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung
                auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
                entfällt
                (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen –
                insbesondere
                Aufbewahrungsfristen – bleiben unberührt.</p>

              <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>

              <p>Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus
                hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei
                uns
                gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
              <p>Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
                mit
                der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich
                ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
                effektiven
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung
                (Art.
                6
                Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.</p>
              <p>Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
                auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
                entfällt
                (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen –
                insbesondere
                gesetzliche Aufbewahrungsfristen – bleiben unberührt.</p>


              <h2>5. Analytics</h2>

              <p>Diese Website nutzt Funktionen des Webanalysedienstes Amazon Pinpoint. Anbieter ist die Amazon Web
                Services
                EMEA SARL, 38 Avenue John F. Kennedy, L-1855, Luxemburg.</p>
              <p>Amazon Pinpoint verwendet so genannte "Cookies". Das sind Textdateien, die auf Ihrem Computer
                gespeichert
                werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie
                erzeugten
                Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Amazon in den
                USA
                übertragen und dort gespeichert.</p>

              <h3>Verwendung von Google Analytics</h3>

              <p>Diese Webseite nutzt Google Analytics, einen Webanalysedienst der Google Inc. (im Folgenden: Google).
                Google Analytics verwendet sog. „Cookies“, also Textdateien, die auf Ihrem Computer gespeichert werden
                und
                die eine Analyse der Benutzung der Webseite durch Sie ermöglichen. Die durch das Cookie erzeugten
                Informationen
                über Ihre Benutzung dieser Webseite werden in der Regel an einen Server von Google in den USA übertragen
                und
                dort gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf diesen Webseiten, wird Ihre
                IP-Adresse
                von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten
                des
                Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle
                IP-Adresse
                an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser
                Webseite
                wird Google diese Informationen benutzen, um Ihre Nutzung der Webseite auszuwerten, um Reports über die
                Webseitenaktivitäten zusammenzustellen und um weitere mit der Webseitennutzung und der Internetnutzung
                verbundene
                Dienstleistungen gegenüber dem Webseitenbetreiber zu erbringen. Die im Rahmen von Google Analytics von
                Ihrem
                Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.</p>
              <p>Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer BrowserSoftware
                verhindern;
                wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen
                dieser
                Webseite vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das
                Cookie
                erzeugten und auf Ihre Nutzung der Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
                Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verfügbare
                Browser-Plugin
                herunterladen und installieren:
                <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">Browser-Add-on zur
                  Deaktivierung
                  von Google Analytics </a>.
              </p>
              <p>Zusätzlich oder als Alternative zum Browser-Add-On können Sie das Tracking durch Google Analytics auf
                unseren Seiten unterbinden, indem Sie diesen Link anklicken. Dabei wird ein Opt-OutCookie auf Ihrem
                Gerät
                installiert. Damit wird die Erfassung durch Google Analytics für diese Website und für diesen Browser
                zukünftig verhindert, so lange der Cookie in Ihrem Browser installiert bleibt.
              </p>

              <h3>Einsatz des Facebook-Pixels (Facebook Custom Audiences)</h3>

              <p>Wir verwenden auf unserer Website den sog. „Facebook-Pixel“ der Facebook Inc. („Facebook“). Dadurch
                können
                den
                Nutzern unserer Website im Rahmen des Besuchs des sozialen Netzwerkes Facebook oder anderer das
                Verfahren
                ebenfalls nutzende Websites interessenbezogene Werbeanzeigen („Facebook-Ads“) dargestellt werden. Durch
                den Facebook-Pixel baut Ihr Browser automatisch eine direkte Verbindung mit dem Server von Facebook auf.
                Wir haben keinen Einfluss auf den Umfang und die weitere Verwendung der Daten, die durch den Einsatz
                dieses
                Tools durch Facebook erhoben werden und informieren Sie daher entsprechend unserem Kenntnisstand: </p>

              <p>Durch die Einbindung des Facebook-Pixels erhält Facebook die Information, dass Sie eine Anzeige von uns
                angeklickt oder die entsprechende Webseite unseres Internetauftritts aufgerufen haben. Sofern Sie bei
                einem Dienst von Facebook registriert sind, kann Facebook den Besuch Ihrem Account zuordnen. Selbst wenn
                Sie nicht bei Facebook registriert sind bzw. sich nicht eingeloggt haben, besteht die Möglichkeit, dass
                der
                Anbieter Ihre IP-Adresse und weitere Identifizierungsmerkmale in Erfahrung bringt und speichert. Mit der
                Verwendung des Facebook-Pixels verfolgen wir den Zweck, von uns geschaltete Facebook-Ads nur solchen
                Facebook-Nutzern anzuzeigen, die auch ein Interesse an unserem Internetangebot gezeigt haben. Mit Hilfe
                des
                Facebook-Pixels möchten wir also sicherstellen, dass unsere Facebook-Ads dem potentiellen Interesse der
                Nutzer
                entsprechen und nicht belästigend wirken. Ferner können wir mit Hilfe des Facebook-Pixels die
                Wirksamkeit
                von
                Facebook-Ads für statistische Zwecke nachvollziehen, in dem wir sehen, ob Nutzer nach dem Klick auf eine
                Facebook-Ad
                auf unsere Website weitergeleitet wurden. Rechtsgrundlage für die Nutzung des Facebook-Pixels ist Art. 6
                Abs. 1 Buchst.
                f DSGVO. </p>


              <h3>Verwendung von Amplitude</h3>

              <p>
                Zweck: Wir verwenden dies Cookies der Amplitude Inc., 631 Howard Street, San Francisco, California
                94105,
                USA, um im Webanalyse-Tool dieses Anbieters auswerten zu können, welche Elemente der Nutzer auf unserer
                Website genutzt hat. Diese Auswertungen dienen uns dazu, möglichst Fehlfunktionen festzustellen und
                unsere
                Website dahingehend optimieren zu können. Diese Nutzungsdaten werden unmittelbar von uns erhoben und
                sodann
                unter einer von uns dem Nutzer zugewiesenen individuellen Kennung auf Servern von Amplitude in den USA
                gespeichert. Die IP-Adresse des Nutzers übermitteln wir Amplitude nicht. Der jeweilige Nutzer ist für
                Amplitude nicht identifizierbar. Damit wir diese Daten nach bestimmten Nutzergruppen auswerten können,
                speichern wir zusätzlich vom pseudonymen Nutzer eingegebene Basisdaten. Der genaue Dateiname der oben
                aufgeführten Cookies kann abweichen. Die Cookies haben verschiedene Funktionen. Die Cookies
                „amplitude_fincraft.de“ und „amplitude_id“ dienen unmittelbar der Erhebung der oben beschriebenen
                Nutzungsdaten und haben eine Speicherdauer von 30 bzw. 29 Tagen. Sonstige Daten werden zu diese
                Session-Cookies nicht gespeichert. Die Datenschutzerklärung von Amplitude finden Sie hier.
                Rechtsgrundlage
                der
                Verarbeitung der zu den Amplitude-Cookies gespeicherten Daten ist – sofern erteilt – Ihre Einwilligung,
                Art.
                6
                Absatz 1 lit. a DSGVO.
              </p>

              <h3>Nutzung des Dienstprogramms Hotjar</h3>

              <p>
                Diese Internetseite nutzt auf einigen Websites den Webanalysedienst Hotjar der Hotjar Ltd.. Hotjar Ltd.
                ist
                ein europäisches Unternehmen mit Sitz in Malta (Hotjar Ltd, Level 2, St Julians Business Centre, 3, Elia
                Zammit Street, St Julians STJ 1000, Malta, Europe)

                Mit diesem Tool lassen sich Bewegungen auf den Websiten, auf denen Hotjar eingesetzt wird,
                nachvollziehen
                (sog. Heatmaps). So ist beispielsweise erkennbar, wie weit Nutzer scrollen und welche Schaltflächen die
                Nutzer wie oft anklicken. Weiterhin ist es mithilfe des Tools auch möglich, Feedback direkt von den
                Nutzern
                der Website einzuholen. Auf diese Weise erlangen wir wertvolle Informationen, um unsere Websites noch
                schneller und kundenfreundlicher zu gestalten.

                Wir achtet beim Einsatz dieses Tools besonders auf den Schutz Ihrer personenbezogenen Daten. So können
                wir
                nur nachvollziehen, welche Schaltflächen angeklickt werden, den Verlauf der Maus, wie weit gescrollt
                wird,
                die Bildschirmgröße des Gerätes, Gerätetyp und Browserinformation, geographischer Standpunkt (nur das
                Land)
                und die bevorzugte Sprache um unsere Website darzustellen. Bereiche der Websites in denen
                personenbezogene
                Daten von Ihnen oder Dritten angezeigt werden, werden von Hotjar automatisch ausgeblendet und sind somit
                zu
                keinem Zeitpunkt nachvollziehbar.

                Hotjar bietet jedem Nutzer die Möglichkeit, mithilfe eines “Do Not Track-Headers” den Einsatz des Tools
                Hotjar zu unterbinden, sodass keine Daten über den Besuch der jeweiligen Website aufgezeichnet werden.
                Es
                handelt sich hierbei um eine Einstellung die alle üblichen Browser in aktuellen Versionen
                unterstützen.
                Hierzu sendet Ihr Browser eine Anfrage an Hotjar, mit dem Hinweis das Tracking des jeweiligen Nutzers zu
                deaktivieren. Sollten Sie sipgate-Websites mit unterschiedlichen Browsern/Rechnern nutzen, müssen Sie
                den
                “Do Not Track-Header” für jeden dieser Browser/Rechner separat einrichten.
                <br/>
                <br/>
                Eine detaillierte Anleitung mit Informationen zu Ihrem Browser finden Sie unter: <a
                href="https://www.hotjar.com/privacy/do-not-track/" target="_blank">https://www.hotjar.com/privacy/do-not-track/</a>
                <br/>
                Weitere Informationen über Hotjar Ltd. und über das Tool Hotjar finden Sie unter: <a
                href="https://www.hotjar.com" target="_blank">https://www.hotjar.com</a>
                <br/>
                Die Datenschutzerklärung der Hotjar Ltd. finden Sie unter: <a href="https://www.hotjar.com/privacy"
                                                                              target="_blank">https://www.hotjar.com/privacy</a>
              </p>

              <h2>6. Newsletter</h2>

              <h3>Newsletterdaten</h3>

              <p>Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine
                E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der
                angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten
                werden
                nicht bzw. nur auf freiwilliger Basis erhoben. Diese Daten verwenden wir ausschließlich für den Versand
                der
                angeforderten Informationen und geben diese nicht an Dritte weiter.</p>
              <p>Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt ausschließlich auf
                Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der
                Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie jederzeit
                widerrufen,
                etwa über den "Austragen"-Link im Newsletter. Die Rechtmäßigkeit der bereits erfolgten
                Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>
              <p>Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu Ihrer
                Austragung aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der
                Abbestellung des Newsletters oder nach Zweckfortfall aus der Newsletterverteilerliste gelöscht. Wir
                behalten
                uns vor, E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem Ermessen im Rahmen unseres
                berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO zu löschen oder zu sperren.</p>
              <p>Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns bzw. dem
                Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, um künftige Mailings zu verhindern. Die
                Daten
                aus der Blacklist werden nur für diesen Zweck verwendet und nicht mit anderen Daten zusammengeführt.
                Dies
                dient sowohl Ihrem Interesse als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim
                Versand von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die
                Speicherung
                in
                der Blacklist ist zeitlich nicht befristet. <strong>Sie können der Speicherung widersprechen, sofern
                  Ihre
                  Interessen unser berechtigtes Interesse überwiegen.</strong></p>


              <h2>7. Plugins und Tools</h2>

              <h3>YouTube mit erweitertem Datenschutz</h3>

              <p>Diese Website bindet Videos der YouTube ein. Betreiber der Seiten ist die Google Ireland Limited
                ("Google"), Gordon House, Barrow Street, Dublin 4, Irland.</p>
              <p>Wir nutzen YouTube im erweiterten Datenschutzmodus. Dieser Modus bewirkt laut YouTube, dass YouTube
                keine
                Informationen über die Besucher auf dieser Website speichert, bevor diese sich das Video ansehen. Die
                Weitergabe von Daten an YouTube-Partner wird durch den erweiterten Datenschutzmodus hingegen nicht
                zwingend
                ausgeschlossen. So stellt YouTube – unabhängig davon, ob Sie sich ein Video ansehen – eine Verbindung
                zum
                Google DoubleClick-Netzwerk her.</p>
              <p>Sobald Sie ein YouTube-Video auf dieser Website starten, wird eine Verbindung zu den Servern von
                YouTube
                hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben. Wenn Sie
                in
                Ihrem YouTube-Account eingeloggt sind, ermöglichen Sie YouTube, Ihr Surfverhalten direkt Ihrem
                persönlichen
                Profil zuzuordnen. Dies können Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.</p>
              <p>Des Weiteren kann YouTube nach Starten eines Videos verschiedene Cookies auf Ihrem Endgerät speichern
                oder
                vergleichbare Wiedererkennungstechnologien (z.B. Device-Fingerprinting) einsetzen. Auf diese Weise kann
                YouTube Informationen über Besucher dieser Website erhalten. Diese Informationen werden u. a. verwendet,
                um
                Videostatistiken zu erfassen, die Anwenderfreundlichkeit zu verbessern und Betrugsversuchen
                vorzubeugen.</p>
              <p>Gegebenenfalls können nach dem Start eines YouTube-Videos weitere Datenverarbeitungsvorgänge ausgelöst
                werden, auf die wir keinen Einfluss haben.</p>
              <p>Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote.
                Dies
                stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende
                Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1
                lit.
                a
                DSGVO; die Einwilligung ist jederzeit widerrufbar.</p>

              <p>Weitere Informationen über Datenschutz bei YouTube finden Sie in deren Datenschutzerklärung unter: <a
                href="https://policies.google.com/privacy?hl=de"
                target="_blank">https://policies.google.com/privacy?hl=de.</a></p>

              <h3>Nutzung von Salesforce</h3>

              <p>finCraft nutzt Dienste von Salesforce (<a href="https://salesforce.com/"
                                                           target="_blank">salesforce.com</a> inc., The Landmark @ One
                Market,
                Suite 300, San Francisco, CA 94105, USA) für die Verwaltung von Kundendaten für Zwecke der
                Verwaltung und des Supports. Mit Salesforce besteht eine Vereinbarung über eine Auftragsverarbeitung und
                die EU-
                Standardvertragsklauseln. Salesforce unterliegt zudem verbindlichen internen
                Datenschutzvorschriften gem. Art. 47 DSGVO, die entsprechend von europäischen
                Datenschutzbehörden verifiziert wurden. Die Datenverarbeitung erfolgt auf in der EU
                befindlichen Servern. Mehr Informationen finden Sie in der Datenschutzerklärung von
                Salesforce: <a href="https://www.salesforce.com/de/company/privacy/"
                               target="_blank">https://www.salesforce.com/de/company/privacy/</a></p>

              <h3>Nutzung von Stripe</h3>

              <p>
                Wir bieten die Möglichkeit, den Zahlungsvorgang über den Zahlungsdienstleister Stripe - Stripe Payments
                Europe Limited 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, D02 H210, Ireland Attention: Stripe
                Legal - abzuwickeln.
              </p>
              <p>
                Dies entspricht unserem berechtigten Interesse, eine effiziente und sichere Zahlungsmethode anzubieten
                (Art. 6 Abs. 1 lit. f DSGVO).
              </p>
              <p>
                In dem Zusammenhang geben wir folgende Daten an Stripe weiter, soweit es für die Vertragserfüllung
                erforderlich ist (Art. 6 Abs. 1 lit b. DSGVO):
              </p>
              <ul>
                <li>
                  Name des Karteninhabers
                </li>
                <li>
                  E-Mail-Adresse
                </li>
                <li>
                  Kundennummer
                </li>
                <li>
                  Bestellnummer
                </li>
                <li>
                  Bankverbindung
                </li>
                <li>
                  Kreditkartendaten
                </li>
                <li>
                  Gültigkeitsdauer der Kreditkarte
                </li>
                <li>
                  Prüfnummer der Kreditkarte (CVC)
                </li>
                <li>
                  Datum und Uhrzeit der Transaktion
                </li>
                <li>
                  Transaktionssumme
                </li>
                <li>
                  Name des Anbieters
                </li>
                <li>
                  Ort
                </li>
              </ul>
              <p>
                Die Verarbeitung der unter diesem Abschnitt angegebenen Daten ist weder gesetzlich noch vertraglich
                vorgeschrieben. Ohne die Übermittlung Ihrer personenbezogenen Daten können wir eine Zahlung über Stripe
                nicht durchführen. Es besteht für Sie die Möglichkeit, eine andere Zahlungsmethode zu wählen.
              </p>
              <p>
                Stripe nimmt bei Datenverarbeitungstätigkeiten eine Doppelrolle als Verantwortlicher und
                Auftragsverarbeiter ein. Als Verantwortlicher verwendet Stripe Ihre übermittelten Daten zur Erfüllung
                regulatorischer Verpflichtungen.
                Dies entspricht dem berechtigten Interesse Stripes (gem. Art. 6 Abs. 1 lit. f DSGVO) und dient der
                Vertragsdurchführung (gem. Art. 6 Abs. 1 lit. b DSGVO). Wir haben auf diesen Prozess keinen Einfluss.
              </p>
              <p>
                Als Auftragsverarbeiter fungiert Stripe, um Transaktionen innerhalb der Zahlungsnetzwerke abschließen zu
                können. Im Rahmen des Auftragsverarbeitungsverhältnisses wird Stripe ausschließlich nach unserer Weisung
                tätig und wurde im Sinne des Art. 28 DSGVO vertraglich verpflichtet, die datenschutzrechtlichen
                Bestimmungen einzuhalten.
              </p>
              <p>
                Stripe hat Compliance-Maßnahmen für internationale Datenübermittlungen umgesetzt. Diese gelten für alle
                weltweiten Aktivitäten, bei denen Stripe personenbezogene Daten von natürlichen Personen in der EU
                verarbeitet. Diese Maßnahmen basieren auf den EU-Standardvertragsklauseln (SCCs).
              </p>
              <p>
                Weitere Informationen zu Widerspruchs- und Beseitigungsmöglichkeiten gegenüber Stripe finden Sie unter:
                <a href="https://stripe.com/privacy-center/legal"
                   target="_blank">https://stripe.com/privacy-center/legal</a>
              </p>
              <p>
                Ihre Daten werden von uns bis zum Abschluss der Zahlungsabwicklung gespeichert. Dazu zählt auch der
                Zeitraum der für die Bearbeitung von Rückerstattungen, Forderungsmanagement und Betrugsprävention
                erforderlich ist.
              </p>


              <h2>8. Informationen zum Datenschutz der BfV Bank für Vermögen AG</h2>

              <p>Die finCraft AG ist im Rahmen der Anlageberatung und Anlagevermittlung von Finanzinstrumenten gem.
                §2 Abs. 2 Nr. 3,4 WpIG ausschließlich für Rechnung und unter der Haftung der BfV Bank für Vermögen
                AG
                tätig. Abweichend hiervon findet die Erstellung des Anlagevorschlages nicht unter dem Haftungsdach der
                BfV
                AG statt wenn der Anwender/Kunde auf die Nutzung seines von finCraft erhobenen Archetypen
                (Investorprofil)
                als Ausgangsbasis seines Investmentprozesses verzichtet. Informationen zum Datenschutz der BfV finden
                Sie
                unter:
                <fin-regulation-document-downloads class="mt-n6" :documents="[datenschutzErstInfo]"
                                                   v-if="datenschutzErstInfo" no-intro/>
              </p>

              <p>Quelle: <a href="https://www.e-recht24.de" target="_blank">https://www.e-recht24.de</a></p>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </fin-data-loader>
</template>


<script>
import FinDataLoader from "@/components/common/DataLoader"
import {finUserAPI} from "@/js/finAPI"
import FinRegulationDocumentDownloads from "@/components/common/DocumentDownloads/RegulationDocumentDownloads"

export default {
  name: "FinDataProtection",
  components: {FinRegulationDocumentDownloads, FinDataLoader},
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datenschutzErstInfo: undefined
    }
  },
  methods: {
    async loadData() {
      let result = await finUserAPI.getDataProtectionFirstInfoDoc()
      this.datenschutzErstInfo = result[0]
      console.log("datenschutzErstInfo", this.datenschutzErstInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles/variables.scss";
@import "./../../styles/home.scss";

.home {

  h1 {
    color: $fin-color-primary-dark !important;
  }

  h2 {
    color: $fin-color-primary-dark !important;
    margin: 40px 0 6px 0;
    font-size: 32px;
    text-align: left;
  }

  h3 {
    padding: 15px 0;
  }

  p {
    color: $fin-color-primary-dark !important;
    margin: 12px 0 6px 0;
  }

  li {
    font-size: 18px;
  }

  .container {
    padding: 32px 45px 32px 32px;
  }

  .col {
    padding-top: 0;
  }

  /* Definition for mobile (375px) - vuetify breakpoint for xs */

  @media only screen and (max-width: 600px) {

    // 23px because of mobiles with 320px
    h1 {
      font-size: 23px;
    }

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
    }

  }
}

</style>
